import auth from '../services/auth';
import session from '../services/session';
import store from '../store/index.js';
import api from '../services/api.js';
import i18n from '../i18n.js';

import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  REMOVE_TOKEN,
  SET_TOKEN,
  SET_USERNAME,
  SET_USER_INFO,
  REGISTRATION_BEGIN,
  REGISTRATION_CLEAR,
  REGISTRATION_SUCCESS,
  REGISTRATION_FAILURE, PASSWORD_RESET_BEGIN, PASSWORD_RESET_SUCCESS, PASSWORD_RESET_FAILURE,
    PASSWORD_CHANGE_BEGIN,
    PASSWORD_CHANGE_SUCCESS,
    PASSWORT_CHANGE_FAILURE,
    SET_BALANCE,
    SET_TASKS,
} from './types';

const TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY';
const USERNAME = 'USERNAME';
const USERINFO = 'USERINFO';
const isProduction = process.env.NODE_ENV === 'production';

const initialState = {
  authenticating: false,
  error: false,
  token: null,
  userinfo: null,
  balance: 0,
  tasks: 0,
};

const getters = {
  isAuthenticated: state => !!state.token,
  getUserInfo: state => JSON.parse(state.userinfo),
  hasGroup: (state) => (group) => {
    if (state.group_details) {
      const groups = JSON.parse(state.group_details)
      console.log('Groups', groups, 'has ' + group, groups.filter(group))
      return groups.some(item => item.name === group)
    } else {
      return false;
    }
  },
  balance: (state) => state.balance,
  tasks: (state) => state.tasks,
  token: (state) => state.token,
};

const actions = {
  async login(context, { username, password }) {
    context.commit(LOGIN_BEGIN);
    return auth.login(username, password)
      .then(({ data }) => context.commit(SET_TOKEN, data.key))
      .then(() => { auth.getAccountDetails().then(async ({ data }) => {
        context.commit(SET_USER_INFO, data, context );
        // todo: refactoring to call directly actions.openTasks, but don't know how (yet)
        const rv = await api.projectkpitasks.fetch({owner: data.pk, completed: false})
        context.commit(SET_TASKS, rv.count)
      })})
      .then(() => context.commit(SET_USERNAME, username))
      .then(() => context.commit(LOGIN_SUCCESS))
        .catch((err) => {
          console.log("Login failed...", err)
          console.log('Store is:', store);
          let message = i18n.global.t('main.Login failed') + ": "
          if (err.response) {
            if (err.response.data) {
              if (err.response.data.email) {
                message = message + err.response.data.email
              }
              if (err.response.data.password1) {
                err.response.data.password1.forEach((item) => {
                  message = message + ' ' + item;
                })
              }
              if (err.response.data.non_field_errors) {
                err.response.data.non_field_errors.forEach((item) => {
                  message = message + ' ' + item;
                })
              }
              if (err.response.data.username) {
                err.response.data.username.forEach((item) => {
                  message = message + ' ' + item;
                })
              }
            }
          }
          store.commit('toast/addToast', {
              title: i18n.global.t('main.Login'),
              type: 'is-danger',
              message: message
          } )
          context.commit(REGISTRATION_FAILURE)
        });
  },
  setBalance({ commit }, { balance }) {
    console.log("STORE: set balance to", balance)
    commit(SET_BALANCE, balance)
  },
  async openTasks(context) {
    const ui = JSON.parse(context.state.userinfo)
    if (ui !== null) {
      const rv = await api.projectkpitasks.fetch({owner: ui.pk, completed: false})
      context.commit(SET_TASKS, rv.count)
    }
  },
  async loginWithGoogle( context, jwt_credentials) {
    context.commit(LOGIN_BEGIN);
    return auth.loginWithGoogle(jwt_credentials)
        .then(({data}) => { context.commit(SET_TOKEN, data.key); context.commit(SET_USERNAME, data.username) })
        .then(() => { auth.getAccountDetails()
        .then(async ({data}) => {
          context.commit(SET_USER_INFO, data, context);
          // todo: refactoring to call directly actions.openTasks, but don't know how (yet)
          const rv = await api.projectkpitasks.fetch({owner: data.pk, completed: false})
          context.commit(SET_TASKS, rv.count)
        }) })
        .then(() => context.commit(LOGIN_SUCCESS))
        .catch(() => context.commit(LOGIN_FAILURE));
  },
  setUserInfo( context ) {
    auth.getAccountDetails()
        .then(({data}) => {
          context.commit(SET_USER_INFO, data, context);
        })
  },
  logout({ commit }) {
    return auth.logout()
      .then(() => commit(LOGOUT))
      .finally(() => commit(REMOVE_TOKEN));
  },
  initialize({ commit }) {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);
    if (isProduction && token) {
      commit(REMOVE_TOKEN);
    }
    if (!isProduction && token) {
      commit(SET_TOKEN, token);
    }
  },
  register({ commit }, { username, password, password1, email }) {
    commit(REGISTRATION_BEGIN);
    return auth.createAccount(username, password, password1, email)
        .then(() => {
          console.log('Store is:', store);
          store.commit('toast/addToast', {
                title: 'main.Registration',
                type: 'is-success',
                message: i18n.global.t('main.Your Registration has been received and an E-Mail ist sent out to you'),
              }
          )
          commit(REGISTRATION_SUCCESS)
        })
        .catch((err) => {
          console.log("Registration failed...", err)
          console.log('Store is:', store);
          let message = i18n.global.t('main.Regiatration failed') + ": ";
          if (err.response) {
            if (err.response.data) {
              if (err.response.data.email) {
                message = message + err.response.data.email
              }
              if (err.response.data.password1) {
                err.response.data.password1.forEach((item) => {
                  message = message + ' ' + item;
                })
              }
              if (err.response.data.non_field_errors) {
                err.response.data.non_field_errors.forEach((item) => {
                  message = message + ' ' + item;
                })
              }
              if (err.response.data.username) {
                err.response.data.username.forEach((item) => {
                  message = message + ' ' + item;
                })
              }
            }
          }
          store.commit('toast/addToast', {
              title: i18n.global.t('main.Registration'),
              type: 'is-danger',
              message: message
          } )
          commit(REGISTRATION_FAILURE)
        });
  },
  resetpassword({ commit }, { email }) {
    commit(PASSWORD_RESET_BEGIN);
    console.log("Password reset requested for ", email)
    return auth.sendAccountPasswordResetEmail(email)
        .then(() => commit(PASSWORD_RESET_SUCCESS))
        .catch(() => commit(PASSWORD_RESET_FAILURE))
  },
  changepassword({ commit }, { password1, password2 }) {
    commit(PASSWORD_CHANGE_BEGIN);
    console.log("Password change requested");
    return auth.changeAccountPassword(password1, password2)
        .then(() => {
          commit(PASSWORD_CHANGE_SUCCESS)
        })
        .catch(() => {
          commit(PASSWORT_CHANGE_FAILURE)
        })
  },
};

const mutations = {
  [LOGIN_BEGIN](state) {
    state.authenticating = true;
    state.error = false;
  },
  [LOGIN_FAILURE](state) {
    state.authenticating = false;
    state.error = true;
  },
  [LOGIN_SUCCESS](state) {
    state.authenticating = false;
    state.error = false;
  },
  [LOGOUT](state) {
    state.authenticating = false;
    state.error = false;
  },
  [SET_TOKEN](state, token) {
    if (!isProduction) localStorage.setItem(TOKEN_STORAGE_KEY, token);
    session.defaults.headers.Authorization = `Token ${token}`;
    state.token = token;
  },
  [SET_USERNAME](state, username) {
    if (!isProduction) localStorage.setItem(USERNAME, username);
  },
  [SET_USER_INFO](state, userinfo, context) {
    localStorage.setItem(USERINFO, JSON.stringify(userinfo));
    state.userinfo = JSON.stringify(userinfo);
    state.balance = userinfo.balance;
  },
  [REMOVE_TOKEN](state) {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
    localStorage.removeItem(USERNAME);
    localStorage.removeItem(USERINFO);
    delete session.defaults.headers.Authorization;
    state.token = null;
    state.userinfo = null;
  },
  [REGISTRATION_BEGIN](state) {
    state.registering = true;
    state.error = false;
  },
  [REGISTRATION_SUCCESS](state) {
    state.registering = false;
    state.error = false;
  },
  [REGISTRATION_FAILURE](state) {
    state.registering = false;
    state.error = true;
  },
  [PASSWORD_RESET_BEGIN](state) {
    state.error = false;
  },
  [PASSWORD_RESET_SUCCESS](state) {
    state.error = false;
  },
  [PASSWORD_RESET_FAILURE](state) {
    state.error = true;
  },
  [SET_BALANCE](state, balance) {
    state.balance = balance;
  },
  [SET_TASKS](state, tasks) {
    state.tasks = tasks;
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};